import { useDispatch, useSelector } from 'react-redux';
import { useFormValueSelector } from '@mews-commander/legacy-form';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ButtonProps, Dialog } from '@optimus-web/core';
import { deleteBill } from '../../../../../modules/billing/actions/bills';
import { closeDialog } from '../../../../../modules/dialog/reducer';
import { isDialogOpen } from '../../../../../modules/dialog/selectors';
import { DELETE_BILL_ACTION_DIALOG } from './actions';

const DeleteBillActionDialog = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state: ApplicationState) => isDialogOpen(state, { name: DELETE_BILL_ACTION_DIALOG }));
    const billId = useFormValueSelector(DELETE_BILL_ACTION_DIALOG, 'billId');
    const scope = useFormValueSelector(DELETE_BILL_ACTION_DIALOG, 'scope');
    const onClose = useFormValueSelector(DELETE_BILL_ACTION_DIALOG, 'onClose');

    const handleDialogClose = () => {
        dispatch(closeDialog(DELETE_BILL_ACTION_DIALOG));
        if (onClose) onClose();
    };

    const handleDeleteBill = async () => {
        // eslint-disable-next-line @typescript-eslint/await-thenable
        await dispatch(deleteBill({ billId, scope }));
        handleDialogClose();
    };

    const dialogActions: Array<ButtonProps> = [
        {
            children: <LocalizedText textKey={TextKey.Close} />,
            onClick: handleDialogClose,
            variant: 'tertiary',
            type: 'button',
        },
        {
            children: <LocalizedText textKey={TextKey.Delete} />,
            onClick: handleDeleteBill,
            variant: 'primary',
            type: 'submit',
        },
    ];

    return (
        <Dialog
            active={isOpen}
            onClose={handleDialogClose}
            title={<LocalizedText textKey={TextKey.DeleteEmptyBillDialogTitle} />}
            actions={dialogActions}
        >
            <LocalizedText textKey={TextKey.DeleteEmptyBillDialogDescription} />
        </Dialog>
    );
};

export default DeleteBillActionDialog;
